<td
  *ngFor="let col of columns"
  [style]="
    'min-width:' + (col.width ? col.width + 'px;' : columnDefaultWidth + 'px;')
  "
>
  <div class="loading-text"></div>
  <p-skeleton [ngStyle]="{ width: '100%' }"></p-skeleton>
</td>
